module.exports = __webpack_public_path__ + "img/home2.bc30a0dc.png";